// выдает правильный вариант написания слова
// 0 - много занятий
// 1 - одно занятие
// 2 - два-три-четыре занятия
// пример заполнения массива для получения правильного слова - [занятий, занятие, занятия]
export var getCorrectNameFromNumber = function (number, arr) {
    if ((arr === null || arr === void 0 ? void 0 : arr.length) < 3)
        return '';
    if ([1].includes(number % 10) && (number % 100 < 10 || number % 100 > 20))
        return arr[1];
    if ([2, 3, 4].includes(number % 10) && (number % 100 < 10 || number % 100 > 20))
        return arr[2];
    return arr[0];
};
//# sourceMappingURL=getCorrectNameFromNumber.js.map// выдает правильный вариант написания слова
// 0 - много занятий
// 1 - одно занятие
// 2 - два-три-четыре занятия
// пример заполнения массива для получения правильного слова - [занятий, занятие, занятия]
export var getCorrectNameFromNumber = function (number, arr) {
    if ((arr === null || arr === void 0 ? void 0 : arr.length) < 3)
        return '';
    if ([1].includes(number % 10) && (number % 100 < 10 || number % 100 > 20))
        return arr[1];
    if ([2, 3, 4].includes(number % 10) && (number % 100 < 10 || number % 100 > 20))
        return arr[2];
    return arr[0];
};
//# sourceMappingURL=getCorrectNameFromNumber.js.map